import { pluralize } from '@/utils/helpers'

const MAX_REACTORS_TO_SHOW = 10

export function getReactionTooltipText(userNames: string[], reaction: string): string {
  const suffix = `reacted with ${reaction}`

  if (userNames.length === 1) {
    return `${userNames[0]} ${suffix}`
  }

  if (userNames.length <= MAX_REACTORS_TO_SHOW) {
    return `${userNames.slice(0, -1).join(', ')} and ${userNames[userNames.length - 1]} ${suffix}`
  }

  return (
    `${userNames.slice(0, MAX_REACTORS_TO_SHOW).join(', ')} and ` +
    `${pluralize(userNames.length - MAX_REACTORS_TO_SHOW, 'other')} ${suffix}`
  )
}
